import { Input, isDevMode, HostBinding } from '@angular/core';
/**
 * @hidden
 */
var ColumnMenuItemBase = /** @class */ (function () {
    function ColumnMenuItemBase() {
        /**
         * Represents the [`ColumnMenuService`]({% slug api_grid_columnmenuservice %}).
         * Requires a mandatory input.
         */
        this.hostClass = true;
    }
    ColumnMenuItemBase.prototype.ngOnInit = function () {
        if (isDevMode() && !this.service) {
            throw new Error('The service input of the predefined column menu components is mandatory.');
        }
    };
    /**
     * @hidden
     */
    ColumnMenuItemBase.prototype.close = function () {
        this.service.close();
    };
    ColumnMenuItemBase.propDecorators = {
        'service': [{ type: Input },],
        'hostClass': [{ type: HostBinding, args: ['class.k-columnmenu-item-wrapper',] },],
    };
    return ColumnMenuItemBase;
}());
export { ColumnMenuItemBase };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/column-menu/column-menu-item-base.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/column-menu/column-menu-item-base.js
// module chunks = vendor